<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-card v-if="user">
          <v-card-title>
            Welcome {{user.name}}!
          </v-card-title>
          <v-card-actions>
            <v-btn block outlined @click="routeToFulfillment">continue</v-btn>
          </v-card-actions>
        </v-card>
      </v-layout>
      <v-dialog v-model="welcomeDialog"
                ref="dialog"
                persistent
                fullscreen
      >

        <v-card v-if="user">
          <v-card-title>
            Welcome {{user.name}}.
          </v-card-title>
          <v-card-actions>
            <v-btn block outlined>continue</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="authDialog"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition">
        <v-app>
          <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
              <app-alert v-if="error" @dismissed="onDismissed" :text="error.message"></app-alert>
              <phone-ui @userVerified="waitToLoadUserData"></phone-ui>
            </v-flex>
          </v-layout>
        </v-app>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import {doc, getDoc} from "firebase/firestore";
// import moment from "moment"
export default {
  props: ['fulfillmentId', 'serviceProviderId'],
  data: () => ({
    serviceData: null,
    authDialog: false,
    welcomeDialog: false,
    fulfillmentData: null
  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  created () {
    // let auth = getAuth()
    // let user = auth.currentUser
    let user = this.$store.getters.user
    if(user) {
      console.log('User at express checkin')
      console.log(user)

    }
    console.log('from express checkin')
    console.log(user)
    //   if (user) {
        // console.log(user)
        // this.authDialog = false
        // this.$store.dispatch('fetchUserData', user)
        // return this.loadFulfillmentData()
      // } else {
        // this.authDialog = true
      // }
  },
  methods: {
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    waitToLoadUserData () {
      console.log('loading user')
      this.authDialog = false
      this.$store.dispatch('setLoading', true)
      setTimeout(this.routeToFulfillment, 2000);
    },
    routeToFulfillment () {
      // this.welcomeDialog = true
      console.log('routing to fulfillment')

      let user = this.$store.getters.user
      console.log(this.fulfillmentId)
      let db = this.$store.state.db
      let fulfillmentDoc = doc(db, 'serviceProviders', user.phoneNumber,
          'fulfillment', this.fulfillmentId)
      return getDoc(fulfillmentDoc)
          .then(res => {
            this.fulfillmentData = res.data()
            console.log(res.data())
            this.verifyETA()
          })
    },
    verifyETA () {
      console.log('on verifyETA')
      console.log(this.fulfillmentData)
      // if(this.fulfillmentData) {
        let cord
        this.$getLocation()
            .then(coordinates => {
              cord = coordinates
              //console.log(cord)
              this.getPickUpAddress = "latlng=" + cord.lat + "," + cord.lng
            })
            .then(() => {
              let gmapPlacesApi = 'https://maps.googleapis.com/maps/api/geocode/json?'
              //flex pickup api
              let apiKey = "AIzaSyCkoOOpVIU1NrXnBrB_uDZl6f_ybcdytl0"
              let params = '&key=' + apiKey
              let placeSearch = gmapPlacesApi + this.getPickUpAddress + params
              return this.axios.get(placeSearch)
            })
            .then((response) => {
              this.searchPickupSpinner = false
              this.approxLocation = response.data.results[0]
              this.getPickUpAddress = ''
              this.fulfillmentData.lastActiveLocation = this.approxLocation
              if(!this.fulfillmentData.locationHistory) {
                this.fulfillmentData.locationHistory = [{...this.approxLocation, created: Date.now()}]
              } else {
                this.fulfillmentData.locationHistory.push({...this.approxLocation, created: Date.now()})
              }
              console.log(this.approxLocation)
              // this.notificationDialog = true
              // this.initEta = true
              // this.notificationDialogTitle = 'Text ETA'
              // this.notificationMsg = "Hi " + this.fulfillmentData.orderData.clientInfo.name
              //     + ". we should be there in " + this.eta + " minutes"
              this.$store.dispatch('setLoading', false)
            })
            .catch(err => {
              this.$store.dispatch('setLoading', false)
              console.log(err)
            })
      // }
    },
    routeServiceProver () {
      // this.$store.dispatch('initCardPayment', paymentObj)
      //path: '/checkSmsAuth/:publicListingId/:routeTo/:routeType/:orderId',
      return this.$router.push(
          '/checkSmsAuth/'
          + this.serviceProviderId
          + '/providerCheck'
          + '/checkIn/'
          + this.linkId
      )
    }
  }

}
</script>

